var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherRooms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.754 0.7007C14.0108 0.493041 14.3477 0.412562 14.6707 0.481709L29.982 3.76029C30.4864 3.86828 30.8467 4.31399 30.8467 4.8298V31.0799C30.8467 31.5954 30.4864 32.041 29.9822 32.1491L14.671 35.4332C14.348 35.5023 14.011 35.422 13.7541 35.2142C13.4972 35.0066 13.3479 34.694 13.3479 34.3637L13.3493 1.55122C13.3493 1.22095 13.4971 0.908359 13.754 0.7007ZM21.0082 17.9548C21.0082 17.0487 20.2736 16.3142 19.3676 16.3142C18.4615 16.3142 17.7269 17.0487 17.7269 17.9548C17.7269 18.8609 18.4615 19.5955 19.3676 19.5955C20.2736 19.5955 21.0082 18.8609 21.0082 17.9548Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1644 2.64737H1.31665C0.712572 2.64737 0.2229 3.13704 0.2229 3.74112V32.1683C0.2229 32.7723 0.712572 33.2621 1.31665 33.2621H11.1644V2.64737Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherRooms);
export default __webpack_public_path__ + "static/media/other-rooms.cf85cda11632703eb1e9995c50312387.svg";
export { ForwardRef as ReactComponent };